import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={34}
    fill="none"
    {...props}
  >
    <path fill="url(#atdollar)" d="M17 1C8.163 1 1 8.163 1 17s7.163 16 16 16V1Z" />
    <path
      fill="#000"
      fillOpacity={0.05}
      d="M17 1C8.163 1 1 8.163 1 17s7.163 16 16 16V1Z"
    />
    <path
      stroke="url(#btdollar)"
      strokeMiterlimit={10}
      d="M17 1C8.163 1 1 8.163 1 17s7.163 16 16 16V1Z"
    />
    <path
      fill="url(#ctdollar)"
      stroke="url(#dtdollar)"
      strokeMiterlimit={10}
      d="M5.923 16.999c0 6.117 4.96 11.077 11.077 11.077 6.118 0 11.077-4.96 11.077-11.077 0-6.118-4.96-11.077-11.077-11.077S5.923 10.882 5.923 16.999Z"
    />
    <path
      fill="url(#etdollar)"
      d="M15.24 24.384v-11.39h-3.86v-2.271h10.45v2.27h-3.858v11.391h-2.733Z"
    />
    <defs>
      <linearGradient
        id="atdollar"
        x1={1}
        x2={17}
        y1={11.153}
        y2={11.233}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.64} stopColor="#ADA23C" stopOpacity={0} />
        <stop offset={1} stopColor="#ADA23C" stopOpacity={0.5} />
      </linearGradient>
      <linearGradient
        id="btdollar"
        x1={0.776}
        x2={17.222}
        y1={17}
        y2={17}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.01} stopColor="#CDC097" />
        <stop offset={0.06} stopColor="#9E9677" />
        <stop offset={0.08} stopColor="#8C866B" />
        <stop offset={0.26} stopColor="#8C866A" />
        <stop offset={0.29} stopColor="#938D6F" />
        <stop offset={0.34} stopColor="#A9A07F" />
        <stop offset={0.39} stopColor="#CBC098" />
        <stop offset={0.45} stopColor="#F5E6B6" />
        <stop offset={0.51} stopColor="#BDB283" />
        <stop offset={0.59} stopColor="#7D7649" />
        <stop offset={0.65} stopColor="#817A52" stopOpacity={0.89} />
        <stop offset={0.84} stopColor="#8C866B" stopOpacity={0.6} />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
      <linearGradient
        id="ctdollar"
        x1={17}
        x2={17.001}
        y1={5.924}
        y2={28.076}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.4} />
        <stop offset={0.325} stopColor="#E6EFF7" />
        <stop offset={0.68} stopColor="#B5BDC3" stopOpacity={0.386} />
        <stop offset={1} stopColor="#DFF5FC" stopOpacity={0.2} />
      </linearGradient>
      <linearGradient
        id="dtdollar"
        x1={17}
        x2={17}
        y1={5.916}
        y2={28.081}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D6E5EA" />
        <stop offset={0.08} stopColor="#A6ABAF" />
        <stop offset={0.26} stopColor="#A5AAAF" />
        <stop offset={0.45} stopColor="#E6F5F9" />
        <stop offset={0.59} stopColor="#7B8AA0" />
        <stop offset={0.84} stopColor="#A6ABAF" />
        <stop offset={1} stopColor="#C1C1C1" />
      </linearGradient>
      <linearGradient
        id="etdollar"
        x1={11.25}
        x2={20.378}
        y1={14.949}
        y2={15.551}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.08} stopColor="#8C866B" />
        <stop offset={0.26} stopColor="#8C866A" />
        <stop offset={0.445} stopColor="#A59A87" />
        <stop offset={0.832} stopColor="#7D7649" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
